import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  errorMessage: '',
  isLoading: false,
  callAgency: false,
  errorMajestic: {
    message: '',
    status: null,
    details: '',
    messageFormatted: '',
    action: '',
    showCallAgency: false,
  },
  idleTimer: {
    showModal: false,
    action: '',
  },
  showAllowFormats: false,
};

const majestic = createSlice({
  name: 'majestic',
  initialState,
  reducers: {
    setErrorMessage(state, { payload }) {
      state.errorMessage = payload.message || '';
      state.callAgency = payload.callAgency || false;
    },
    setIsLoading(state, { payload }) {
      state.isLoading = payload;
    },
    setErrorMajestic(state, { payload }) {
      state.errorMajestic.message = payload.message || '';
      state.errorMajestic.status = payload.status || null;
      state.errorMajestic.details = payload.details || '';
      state.errorMajestic.messageFormatted = payload.messageFormatted || '';
      state.errorMajestic.action = payload.action || '';
      state.errorMajestic.showCallAgency = payload.showCallAgency || false;
    },
    setIdleTimer(state, { payload }) {
      state.idleTimer.showModal = payload.showModal || false;
      state.idleTimer.action = payload.action || '';
    },
    setShowAllowFormats(state, { payload }) {
      state.showAllowFormats = payload.show || false;
    },
  },
});

export const {
  setIsLoading,
  setErrorMessage,
  setErrorMajestic,
  setIdleTimer,
  setShowAllowFormats,
} = majestic.actions;
export default majestic.reducer;
